import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { linkWorkItems, LinkWorkItemsPayload } from '../api/linkWorkItems';

export const useLinkWorkItemsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: LinkWorkItemsPayload) => linkWorkItems(payload),
    onSuccess: () => {
      toast.success('Work item linked successfully');
      // Refresh general tasks list and specific task detail queries
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
      queryClient.invalidateQueries({ queryKey: ['task'] });
    },
    onError: (error: any) => {
      console.error('Failed to link items', error);
      toast.error(error.message || 'Failed to link work items.');
    },
  });
};
